import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import { UserSettingsPage } from '@backstage/plugin-user-settings';

export const userSettingsPluginOverride = userSettingsPlugin.withOverrides({
  extensions: [
    userSettingsPlugin.getExtension('page:user-settings').override({
      params: {
        path: '/settings',
        noHeader: true,
        loader: async () => <UserSettingsPage />,
      },
    }),
  ],
});
